<template>
  <div id="about" class="hello">
    <h2>{{ msg }}</h2>
    <b-container class="home-content mt-5 mb-5">
      <b-row class="justify-content-md-center">
        <b-col md="8" class="text-center">
          <p>
            We are students majoring in Computer Science at Borough of Manhattan Community College.
          </p>
        </b-col>
      </b-row>
      <b-row class="justify-content-md-center">
        <b-col md="8" class="text-center">
          <b-row class="justify-content-md-center">
            <b-col md="4" class="text-center">
              <img alt="covid banner" src="../assets/face-recognition.svg"><br/>
              <a href="https://github.com/marshall-kapfudza" target="_blank">Marshall Kapfudza</a>
              <p>Student</p>
            </b-col>
            <b-col md="" class="text-center">
              <img alt="covid banner" src="../assets/face-recognition.svg"><br/>
              <a href="https://github.com/ahmedesoliman" target="_blank">Ahmed Soliman</a>
              <p>Student</p>
            </b-col>
            <b-col md="" class="text-center">
              <img alt="covid banner" src="../assets/face-recognition.svg"><br/>
              <a href="https://www.bmcc.cuny.edu/faculty/mohammad-azhar/" target="_blank">DR. Mohammad Azhar</a>
              <p>Mentor</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    
    <p class="students"><code>© bmcc students</code></p>
  </div>
</template>

<script>
export default {
  name: 'Covid 19',
  props: {
    msg: String
  }
}
const intID = encodeURI('e8343843-66c4-4a96-8fcf-df492637776b');
const serviceID = encodeURI('30a3b36f-afa6-45be-b919-01637ecc7120');
const url = encodeURI('https://web-chat.global.assistant.watson.appdomain.cloud/loadWatsonAssistantChat.js');
window.watsonAssistantChatOptions = {
  integrationID: intID,
  region: 'us-east',
  serviceInstanceID: serviceID,
  onLoad: (instance) => { instance.render(); },
};
setTimeout(() => {
  const t = document.createElement('script');
  t.src = url;
  document.head.appendChild(t);
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
a {
  color: #42b983;
}
img {
  max-width: 120px !important;
}
</style>
